import { useEffect } from "react";

import { useBoolean } from "usehooks-ts";

export default function useIsMounted() {
	const { value, setTrue, setFalse } = useBoolean(false);

	useEffect(() => {
		setTrue();

		return setFalse;
	});

	return value;
}
